export default class extends Controller {
  static targets = ["notifyCheckbox", "notifyFieldsContainer"];

  connect() {
    this.toggleNotifyFields();
  }

  toggleNotifyFields() {
    this.showNotifyFields = this.shouldNotify;
  }

  //
  // GETTERS AND SETTERS
  //

  get shouldNotify() {
    return !!this.notifyCheckboxTarget.checked;
  }

  set showNotifyFields(val) {
    App.Helpers[`${val ? "show" : "hide"}Element`](this.notifyFieldsContainerTarget);
  }
};



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-invitees-form-fields-controller.js